<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Dispute List</h1>
            <div class="content-wrap">
                <div class="table-responsive">
                <table class="ui celled table hover" datatable [dtOptions]="dtOptions">
                    <thead>
                        <tr>
                          <th>Application Id</th>
                          <th>Contact Person</th>
                          <th>Document</th>
                          <th>Status</th>
                          <th>Preview Document</th>
                          <th>View Details</th>
                        </tr>
                      </thead>
                      <tbody>
                       <tr *ngFor="let data of data">
                             <td>{{data.applicationId}}</td>
                             <td>{{data.contactPerson}}</td>
                             <td>{{data.document}}</td>
                             <td>{{data.status}}</td>
                             <td><button class='action-btn bg-theme' data-toggle="modal" data-target="#viewModal">Preview</button></td>
                             <td><button class='action-btn bg-theme' data-toggle="modal" data-target="#disputeDetails">View</button></td>
                         </tr>
                      </tbody>
                  </table>
                </div>
            </div>
    `   </div>
    </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
              <div class="col-md-6">
                  <img src="assets/images/certificate.jpg" alt="Certificate" class="doc-img">
                  <p class="doc-txt">To be verified</p>
              </div>
              <div class="col-md-6">
                <img src="assets/images/certificate.jpg" alt="Certificate" class="doc-img">
                <p class="doc-txt">System document</p>
              </div>
          </div>
        </div>
      </div>
    </div>
</div>

<div class="modal fade" id="disputeDetails" tabindex="-1" role="dialog" aria-labelledby="disputeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title" id="disputeModalLabel">Dispute Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                  <div class="form-group input-group-lg">
                      <label for="phoneNumber" class="form-label mb-0">Application Id</label>
                      <span class="appId">AP234</span>
                  </div>
                </div>
            </div>
          <div class="row">
              <div class="col-md-12">
                <div class="form-group input-group-lg">
                    <label for="phoneNumber" class="form-label mb-0">Contact Person Name</label>
                    <span class="appId">Ramesh Singh</span>
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <label for="phoneNumber" class="form-label mb-0">Contact Person Number</label>
                <span class="appId">+91 9877677557</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <label for="phoneNumber" class="form-label mb-0">Contact Person Email</label>
                <span class="appId">ramesh@gmail.com</span>
              </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <label for="phoneNumber" class="form-label mb-0">Dispute Reason</label>
                <span class="appId">The reason for this dispute is lorum ipsum 
                    kolo donar. The reason for this dispute is 
                    lorum ipsum kolo donar. The reason for this 
                    dispute is lorum ipsum kolo donar. </span>
              </div>
            </div>
        </div>
          <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal">Dispute Solved</button>
          <button class="reject-modal-btn mr-auto" data-dismiss="modal">Not a Dispute</button>
        </div>
      </div>
    </div>
</div>

